__turbopack_context__.v({
  "emptyContainer": "results-module__D26q3a__emptyContainer",
  "emptyIcon": "results-module__D26q3a__emptyIcon",
  "emptySubtext": "results-module__D26q3a__emptySubtext",
  "emptyText": "results-module__D26q3a__emptyText",
  "resultsContainer": "results-module__D26q3a__resultsContainer",
  "resultsHeader": "results-module__D26q3a__resultsHeader",
  "resultsList": "results-module__D26q3a__resultsList",
  "resultsListEmpty": "results-module__D26q3a__resultsListEmpty",
});
